'use client';

import React from 'react';
import { BottomBar } from '@/widgets/BottomBar';
import { MedcenterBookingButtons } from './MedcenterBookingButtons';
import type { IMedcenterDetails } from '@/entities/medcenter/model/types';
interface Props {
  medcenter: IMedcenterDetails;
  hasPhones: boolean;
}
export const MedcenterBottomBar: React.FC<Props> = ({
  medcenter,
  hasPhones
}) => {
  return <BottomBar variant={'glassmorphism'} align={'flex'} data-sentry-element="BottomBar" data-sentry-component="MedcenterBottomBar" data-sentry-source-file="MedcenterBottomBar.tsx">
      <div className="flex w-full items-center gap-2">
        <MedcenterBookingButtons medcenter={medcenter} hasPhones={hasPhones} data-sentry-element="MedcenterBookingButtons" data-sentry-source-file="MedcenterBottomBar.tsx" />
      </div>
    </BottomBar>;
};